exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CardView{background:#f9f9f9;width:100%;height:100vh;min-height:570px;display:flex;align-items:center;justify-content:center;flex-direction:column;position:relative}.CardView .spinner{height:100%;z-index:999;background-color:hsla(0,0%,100%,.8)}.CardView .replay,.CardView .spinner{display:flex;align-items:center;justify-content:center;width:100%;position:absolute;flex-direction:column}.CardView .replay{z-index:9;height:100vh;background-color:rgba(0,0,0,.75)}.CardView .replay .text{color:#fff;margin-bottom:20px;font-size:24px}.CardView .replay .btn-outline-secondary{font-size:18px}.CardView .NotFound{font-size:30px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/CardView/style.scss
// module id = 5150
// module chunks = 0